import MarkdownEditor from "@/component/Markdown/MarkdownEditor";
import MarkdownPreview from "@/component/Markdown/MarkdownPreview";
import { SUMMARY_TEXTAREA_ID } from "@/constants/record";
import summaryStore from "@/store/summary.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import { useEffect } from "react";

const MeetingSummary = () => {
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);
  const summary = summaryStore((state) => state.summary);
  const modifySummary = summaryStore((state) => state.modifySummary);
  const newSummary = summaryStore((state) => state.newSummary);
  const isMobile = summaryCommonStore((state) => state.isMobile);

  const handleEditContent = (content: string, index: number) => {
    if (!newSummary) return;
    modifySummary({
      ...newSummary,
      meetingSummary: newSummary.meetingSummary.map((item, _index) => {
        if (index === _index) {
          return content;
        }
        return item;
      }),
    });
  };

  useEffect(() => {
    if (summaryEditing) {
      const dom = document.getElementById(
        SUMMARY_TEXTAREA_ID
      ) as HTMLTextAreaElement;
      dom?.focus();
      // 光标移到最后
      dom?.setSelectionRange(dom.value.length, dom.value.length);
    }
  }, [summaryEditing]);

  return (
    <div
      className={`mt-2.5 w-full text-3.5 text-justify font-normal lh-7  select-text ${
        isMobile ? "text-#30343C" : "text-mx-tertiary"
      } `}
    >
      {summary?.srcAiGcContent?.meetingSummary?.map((item, index) =>
        summaryEditing ? (
          <MarkdownEditor
            key={index}
            id={index.toString()}
            mode="wysiwyg"
            initialValue={item}
            onChange={(content) => handleEditContent(content, index)}
          />
        ) : (
          <MarkdownPreview key={index} value={item} />
        )
      )}
    </div>
  );
};

export default MeetingSummary;
